module.exports = __webpack_public_path__ + "static/media/points-bene.9e40d4e0.svg";